import type { VideoColumnProps } from '@modules/page-builder/types';
import type { ImageProps } from '@archipro-design/aria';

export const getVideoCoverImage = (
    column: VideoColumnProps,
    isMobile: boolean,
    previewSrc?: string,
) => {
    const showFilled = Boolean(previewSrc || column.video?.coverImage);

    const coverImgSrc =
        previewSrc ??
        column.video?.coverImage ??
        column?.video?.coverImageThumbnail ??
        '#';

    return {
        src: coverImgSrc,
        width: isMobile ? column.dimension.mobileWidth : column.dimension.width,
        height: isMobile
            ? column.dimension.mobileHeight
            : column.dimension.height,
        layout: showFilled ? 'fill' : 'intrinsic',
        placeholderColor: 'dark',
        objectFit: 'cover',
        objectPosition: 'center',
    } as ImageProps;
};
